import { getToken, getActiveTenantId } from '../api/client';

// PDF / binary download helper that respects our X-Session-Token auth.
// `<a href>` and `window.open()` don't carry custom headers, so we fetch the
// blob ourselves, hand it to the browser via an object-URL, and revoke after
// a minute to keep memory clean. Same pattern used for invoice PDF downloads.
export async function downloadAuthorisedBlob(url: string, filename?: string): Promise<void> {
  const headers: Record<string, string> = { Accept: 'application/octet-stream' };
  const t = getToken();
  if (t) headers['X-Session-Token'] = t;
  const tid = getActiveTenantId();
  if (tid != null) headers['X-Tenant-Id'] = String(tid);

  const r = await fetch(url, { headers });
  if (!r.ok) {
    let msg = `${r.status} ${r.statusText}`;
    try {
      const j = await r.json();
      if (j?.error?.message) msg = j.error.message;
    } catch { /* not JSON */ }
    throw new Error(msg);
  }
  const blob = await r.blob();
  const objectUrl = URL.createObjectURL(blob);
  if (filename) {
    // Force a download with the chosen filename.
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } else {
    // Open inline (browser PDF viewer).
    window.open(objectUrl, '_blank', 'noopener,noreferrer');
  }
  // Free the blob URL after a minute — long enough for the browser to load it.
  setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
}
